import { LegacyCard } from "@payping/web-components";
import React from "react";
import { FormInstance } from "@payping/web-components/legacyComponents/Form/types";
import ManualAddition from "./manualAddition";
import { SettlementRowType } from "./secondStep";

interface Props {
  form: FormInstance<SettlementRowType>;
  loadingList: boolean;
}
const ManualRequest: React.FC<Props> = ({ form, loadingList }: Props) => {
  return (
    <LegacyCard.Ant>
      <ManualAddition loadingList={loadingList} form={form} />
    </LegacyCard.Ant>
  );
};

export default ManualRequest;
